import {ADD_MESSAGE} from "../constants/action-types";

export const addMessage = (type, text) => ({
  type: ADD_MESSAGE,
  payload: {
    type,
    text
  }
});
